// tslint:disable-next-line:no-namespace
namespace HA.Core.HTML.Media {

    import FSApp = HA.Core.Entity.FSApp;

    export class Gallery extends Container {

        protected createSelf() {
            super.createSelf();
            this.addClass("gallery")
            const gallery = this.get("medias");
            const total = gallery.length;
            const fc = this.get("fc");
            const cont = fc ? new FlexContainer() : new CFlexContainer();
            const ctac = new Div({class: "gcta", txt : total + " image(s)"  });
            //const cta = new Tag({html: "<i></i> " + total + " image(s)", classes: ["rimg", "fad", "fa-camera"]});
            this.addToData("cta", ctac);
            //ctac.appendChild(cta);

            const uimg = new UImg({mid: gallery[0]});
            uimg.appendChild(ctac);

            cont.appendChild(uimg);

            cont.onClick(() => {
                this.handleClick();
            });

            this.appendChild(cont);
        }

        private getCTA(): Tag {
            return this.get("cta");
        }

        private closeModal(): void {
            getAppService().closeFSApp(this.getAppId());
        }

        private handleClick(): void {
            const app2 = HA.Core.Service.App.createFSApp(this.loadGallery());
            this.setAppId(app2.getId());
            this.showModal(app2);
        }

        private loadGallery(): CFlexContainer {
            const me = this;
            const cont = new Window(toMap({
                wcancel: () => {
                    me.closeModal();
                },
            }));

            const sc = [];
            const name = this.get("name");
            const medias = this.get("medias");
            const t = medias.length;
            let p = 1;
            medias.forEach((id: string) => {
                sc.push({
                    "t": "div",
                    "class": "imgc",
                    "c": [
                        {
                            "t": "uimg",
                            "ti": name + " " + (p++) + "/" + t,
                            "mid": id
                        }
                    ]
                })
            });

            cont.appendChild(new Slider({
                "t": "slider",
                "class": "swiper",
                "pagination": true,
                "prev": true,
                "next": true,
                "scrollbar": true,
                "sc": sc
            }))
            return cont;
        }

        private showModal(app: FSApp) {
            getAppService().showFSApp(app);
        }

        private setAppId(id: string) {
            return this.addToData("_appId", id);
        }

        private getAppId(): string {
            return this.get("_appId");
        }
    }
}
